import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  pageTitle: ReactNode;
  uris: string[];
};

const HeroSection = ({ pageTitle, uris }: Props) => {
  const parentPages = uris.slice(0, -1);
  const currentPage = uris.slice(-1);
  return (
    <section className="page-title position-relative pt-8 pb-5" style={{ backgroundColor: 'rgba(30, 80, 255, 0.05)' }}>
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <h1 className="mb-4">{pageTitle}</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="bi bi-house-door me-1"></i>Home
                  </Link>
                </li>
                {parentPages.map(page => (
                  <li key={page} className="breadcrumb-item">
                    {page}
                  </li>
                ))}
                <li className="breadcrumb-item active" aria-current="page">
                  {currentPage}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="shadow-1"></div>
    </section>
  );
};

export default HeroSection;
